<app-qr-reader></app-qr-reader>